import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import '../../css/growthWheel.scss'
import {
  useGetGrowthWheelByRoleIdQuery,
  useGetGrowthWheelWithEvaluationsByUserIdQuery
} from '../../redux/growth-wheel.endpoints'
import {
  setGrowthWheelData,
  setUserCompetencyAreasData,
  setLoadingGrowthWheel,
  setCurrentCompetencyArea,
  setCurrentCompetency,
  evaluateFocusCompetenciesLimit,
  setCurrentAreasOfFocus,
} from '../../redux/growthWheel.slice'
import { RootState } from '../../redux/store'
import { User } from '../../types/User'
import GrowthWheelDashboard from '../GrowthWheelDashboard/GrowthWheelDashboard'
import GrowthWheelCompetencyAreaView from '../GrowthWheelCompetencyAreaView/GrowthWheelCompetencyAreaView'
import GrowthWheelCompetencyAssessment from '../GrowthWheelCompetencyView/GrowthWheelCompetencyView'

const GrowthWheel = ({ user }: { user: User }) => {
  const dispatch = useDispatch()
  const roleId = user.guildId

  const { data: growthWheelData, isLoading } = useGetGrowthWheelByRoleIdQuery(
    { roleId },
    { refetchOnMountOrArgChange: true },
  )
  const { data: userCompetencyAreasData } =
    useGetGrowthWheelWithEvaluationsByUserIdQuery(
      { userId: user.id },
      { refetchOnMountOrArgChange: true },
    )  

  const currentCompetencyArea = useSelector((state: RootState) => state.growthWheel.currentCompetencyArea)
  const currentCompetency = useSelector((state: RootState) => state.growthWheel.currentCompetency)

  useEffect(() => {
    dispatch(setGrowthWheelData(growthWheelData ?? null))
  }, [dispatch, growthWheelData])

  useEffect(() => {
    dispatch(setUserCompetencyAreasData(userCompetencyAreasData ?? []))
    dispatch(evaluateFocusCompetenciesLimit())
    dispatch(setCurrentAreasOfFocus())
  }, [dispatch, userCompetencyAreasData])

  useEffect(() => {
    dispatch(setLoadingGrowthWheel(isLoading))
  }, [dispatch, isLoading])

  useEffect(() => {
    if (!userCompetencyAreasData?.length) return
    if (currentCompetencyArea) {
      const freshArea = userCompetencyAreasData.find((a) => a.id === currentCompetencyArea.id)
      if (freshArea) {
        dispatch(setCurrentCompetencyArea(freshArea))
        if (currentCompetency) {
          const freshCompetency = freshArea.competencies?.find((c) => c.id === currentCompetency.id)
          if (freshCompetency) dispatch(setCurrentCompetency(freshCompetency))
        }
      }
    }
  }, [userCompetencyAreasData, currentCompetencyArea, currentCompetency, dispatch])

  const displayAssessmentView = currentCompetency && currentCompetencyArea
  const displayAreaView = currentCompetencyArea && !currentCompetency
  const displayDashboardView = !currentCompetencyArea && growthWheelData

  if (displayAssessmentView) {
    return <GrowthWheelCompetencyAssessment />
  }
  if (displayAreaView) {
    return <GrowthWheelCompetencyAreaView />
  }
  if (displayDashboardView) {
    return <GrowthWheelDashboard />
  }
  return null
}

export default GrowthWheel